import React from 'react'
import { Route } from 'react-router'

import App from '_views/app'
import Home from '_views/home'
import NotFound from '_views/not-found'
import Login from '_views/login'
import SignUp from '_views/signup'
import Log from '_views/log'
import Settings from '_views/settings'
import MindfulBreaks from '_views/mindful-breaks'
import ResetPassword from '_views/reset-password'
import ForgotPassword from '_views/forgot-password'
import Subscribe from '_views/subscribe'
import TodayList from '_views/today-items'
import CaptureItems from '_views/capture'
import Terms from '_views/terms'
import Profile from '_views/profile'
import Collaborate from '_views/collaborate'
import Admin from '_views/admin'
import ConfirmEmail from '_views/confirm-email'
import TomorrowList from '_views/tomorrow-items'
import Reconcile from '_views/reconcile'
import Search from '_views/search'

import {
  adminLoginRequired,
  userLoginAndEmailConfirmRequired,
  proPlanRequired,
  teamPlanRequired,
} from './utils/routes'

const routes = store => (
  <Route component={App}>
    <Route path="/" component={Home} />
    <Route path="/login" component={Login} />
    <Route path="/sign-up" component={SignUp} />
    <Route path="/reset" component={ResetPassword} />
    <Route path="/forgot" component={ForgotPassword} />
    <Route path="/terms" component={Terms} />
    <Route path="/profile" component={Profile} onEnter={userLoginAndEmailConfirmRequired(store)} />
    <Route
      path="/reconcile"
      component={Reconcile}
      onEnter={userLoginAndEmailConfirmRequired(store)}
    />
    <Route path="/log" component={Log} onEnter={userLoginAndEmailConfirmRequired(store)} />
    <Route
      path="/settings"
      component={Settings}
      onEnter={userLoginAndEmailConfirmRequired(store)}
    />
    <Route
      path="/break"
      component={MindfulBreaks}
      onEnter={userLoginAndEmailConfirmRequired(store)}
    />
    <Route
      path="/subscribe"
      component={Subscribe}
      onEnter={userLoginAndEmailConfirmRequired(store)}
    />
    <Route path="/today" component={TodayList} onEnter={proPlanRequired(store)} />
    <Route path="/tomorrow" component={TomorrowList} onEnter={proPlanRequired(store)} />
    <Route path="/capture" component={CaptureItems} onEnter={proPlanRequired(store)} />
    <Route path="/collaborate" component={Collaborate} onEnter={teamPlanRequired(store)} />
    <Route path="/admin" component={Admin} onEnter={adminLoginRequired(store)} />
    <Route path="/confirm-email" component={ConfirmEmail} />
    <Route path="/search" component={Search} />
    <Route path="*" component={NotFound} />
  </Route>
)

export default routes



// WEBPACK FOOTER //
// ./src/routes.js